module.exports = __webpack_public_path__ + "src/assets/img/loading/2ac0e6239bad89c5edb48291e083a14f.png";